import { render, staticRenderFns } from "./shopJournal.vue?vue&type=template&id=3b0c61fe&scoped=true&"
import script from "./shopJournal.vue?vue&type=script&lang=js&"
export * from "./shopJournal.vue?vue&type=script&lang=js&"
import style0 from "./shopJournal.vue?vue&type=style&index=0&id=3b0c61fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c61fe",
  null
  
)

export default component.exports